import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentOverview } from '../components/AgentWorkforce';

const MyAIEmployees = () => {
  const navigate = useNavigate();

  const handleChatClick = (agent) => {
    navigate(`/ai-employee-workspace/${agent._id}`);
  };

  return (
    <AgentOverview onChatClick={handleChatClick} />
  );
};

export default MyAIEmployees; 